<template>
  <div>
    <h1 class="text-2xl font-bold text-gray-900 mb-6">Configurações da Empresa</h1>
    
    <!-- Abas de navegação -->
    <div class="bg-white rounded-t-xl shadow-sm border border-gray-100 border-b-0">
      <div class="flex border-b border-gray-200">
        <button
          @click="activeTab = 'general'"
          :class="[
            'px-6 py-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2',
            activeTab === 'general'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ]"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
          Informações Gerais
        </button>
        <button
          @click="activeTab = 'appearance'"
          :class="[
            'px-6 py-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2',
            activeTab === 'appearance'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ]"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"></path>
          </svg>
          Aparência
        </button>
        <button
          @click="activeTab = 'delivery'"
          :class="[
            'px-6 py-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2',
            activeTab === 'delivery'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ]"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"></path>
          </svg>
          Delivery
        </button>
        <button
          @click="activeTab = 'hours'"
          :class="[
            'px-6 py-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2',
            activeTab === 'hours'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ]"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Horários
        </button>
        <button
          @click="activeTab = 'mercadopago'"
          :class="[
            'px-6 py-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2',
            activeTab === 'mercadopago'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          ]"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
          </svg>
          Mercado Pago
        </button>
      </div>
    </div>
    
    <!-- Conteúdo das abas -->
    <div class="bg-white rounded-b-xl shadow-sm border border-gray-100 border-t-0 p-6">
      
      <!-- Aba: Informações Gerais -->
      <div v-if="activeTab === 'general'" class="space-y-6 max-w-2xl">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Nome da Empresa</label>
          <input v-model="company.name" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
          <textarea v-model="company.description" rows="3" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500"></textarea>
        </div>
        
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
            <input v-model="company.phone" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
            <input v-model="company.whatsapp" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input v-model="company.email" type="email" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
        </div>
        
        <!-- Redes Sociais -->
        <div class="border-t pt-6">
          <h3 class="text-sm font-semibold text-gray-900 mb-4">Redes Sociais</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Facebook</label>
              <input 
                v-model="company.facebook_url" 
                type="url"
                placeholder="https://facebook.com/sua-pagina"
                class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Instagram</label>
              <input 
                v-model="company.instagram_url" 
                type="url"
                placeholder="https://instagram.com/sua-conta"
                class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">X (Twitter)</label>
              <input 
                v-model="company.twitter_url" 
                type="url"
                placeholder="https://x.com/sua-conta"
                class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
              <input 
                v-model="company.whatsapp" 
                type="text"
                placeholder="5511999999999"
                class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
              />
              <p class="text-xs text-gray-500 mt-1">Formato: 55 + DDD + número (somente números)</p>
            </div>
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
          <input v-model="company.address" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
        </div>
        
        <div class="grid grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
            <input v-model="company.city" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Estado</label>
            <input v-model="company.state" class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">CEP</label>
            <input
              v-model="company.zip_code"
              @blur="searchCep"
              @keydown.enter.prevent="searchCep"
              placeholder="00000-000"
              class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              :class="{ 'border-red-500': cepError }"
            />
            <p v-if="cepError" class="text-xs text-red-600 mt-1">{{ cepError }}</p>
          </div>
        </div>
        
        <!-- URL do Sistema (SaaS) -->
        <div class="border-t pt-6 mt-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              URL do Sistema
            </label>
            <input 
              v-model="company.system_url" 
              type="url"
              placeholder="https://minhaempresa.com"
              class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
            />
            <p class="text-xs text-gray-500 mt-1">
              URL personalizada usada para retorno de pagamentos. Se não informada, será usado o endereço atual.
            </p>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">URL Padrão do Subdomínio</label>
            <p class="text-sm text-gray-900">
              {{ company.subdomain ? `https://${company.subdomain}.${company.custom_domain_base || company.domain_base || 'deliveryapphub.com'}` : 'Não configurado' }}
            </p>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Domínio Próprio</label>
            <p class="text-sm text-gray-900">
              {{ company.custom_domain ? `https://${company.custom_domain}` : 'Não configurado' }}
            </p>
            <p class="text-xs text-gray-500 mt-1">
              O domínio próprio deve ser configurado pelo Super Admin.
            </p>
          </div>
        </div>
        
        <div class="pt-4">
          <button
            @click="saveSettings"
            :disabled="saving"
            class="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="saving" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ saving ? 'Salvando...' : 'Salvar Configurações' }}
          </button>
        </div>
      </div>
      
      <!-- Aba: Cores e Aparência -->
      <div v-if="activeTab === 'appearance'" class="space-y-6 max-w-2xl">
        <div class="grid grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Cor Primária</label>
            <div class="flex items-center gap-3">
              <input 
                v-model="company.primary_color" 
                type="color" 
                class="w-12 h-12 rounded-lg border cursor-pointer"
              />
              <input 
                v-model="company.primary_color" 
                type="text" 
                class="flex-1 border rounded-lg px-3 py-2 uppercase"
                maxlength="7"
              />
            </div>
            <p class="text-xs text-gray-500 mt-1">Usada nos botões e elementos principais</p>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Cor Secundária</label>
            <div class="flex items-center gap-3">
              <input 
                v-model="company.secondary_color" 
                type="color" 
                class="w-12 h-12 rounded-lg border cursor-pointer"
              />
              <input 
                v-model="company.secondary_color" 
                type="text" 
                class="flex-1 border rounded-lg px-3 py-2 uppercase"
                maxlength="7"
              />
            </div>
            <p class="text-xs text-gray-500 mt-1">Usada em elementos secundários</p>
          </div>
        </div>
        
        <!-- Logo Upload -->
        <div class="border-t pt-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">Logo da Empresa</label>
          <p class="text-xs text-gray-500 mb-3">Esta imagem será exibida no cabeçalho do site</p>
          
          <div class="flex items-start gap-6">
            <!-- Logo Preview -->
            <div class="w-32 h-32 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden border">
              <img 
                v-if="company.logo_url || logoPreview"
                :src="logoPreview || getImageUrl(company.logo_url)"
                alt="Logo Preview"
                class="w-full h-full object-contain p-2"
              >
              <div v-else class="text-center text-gray-400">
                <PhotoIcon class="h-10 w-10 mx-auto mb-1" />
                <span class="text-xs">Sem logo</span>
              </div>
            </div>
            
            <!-- Upload Controls -->
            <div class="flex-1">
              <input
                ref="logoInput"
                type="file"
                accept="image/*"
                class="hidden"
                @change="handleLogoChange"
              >
              <div class="flex gap-2">
                <button
                  @click="triggerLogoInput"
                  type="button"
                  class="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm font-medium transition-colors"
                >
                  {{ company.logo_url ? 'Trocar Logo' : 'Escolher Logo' }}
                </button>
                <button
                  v-if="company.logo_url || logoFile"
                  @click="removeLogo"
                  type="button"
                  class="px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg text-sm font-medium transition-colors"
                >
                  Remover
                </button>
              </div>
              <p class="text-xs text-gray-500 mt-2">
                Formatos aceitos: JPG, PNG, WEBP<br>
                Tamanho máximo: 2MB<br>
                Recomendado: 200x200px
              </p>
            </div>
          </div>
        </div>
        
        <div class="p-4 bg-gray-50 rounded-lg">
          <h4 class="text-sm font-medium text-gray-700 mb-3">Pré-visualização</h4>
          <div class="flex gap-3">
            <button 
              class="px-4 py-2 rounded-lg text-white font-medium"
              :style="{ backgroundColor: company.primary_color }"
            >
              Botão Primário
            </button>
            <button 
              class="px-4 py-2 rounded-lg text-white font-medium"
              :style="{ backgroundColor: company.secondary_color }"
            >
              Botão Secundário
            </button>
          </div>
        </div>
        
        <div class="pt-4">
          <button
            @click="saveSettings"
            :disabled="saving"
            class="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="saving" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ saving ? 'Salvando...' : 'Salvar Configurações' }}
          </button>
        </div>
      </div>
      
      <!-- Aba: Configurações de Delivery -->
      <div v-if="activeTab === 'delivery'" class="space-y-6 max-w-2xl">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Valor Mínimo do Pedido (R$)</label>
            <input 
              v-model="minOrderValueFormatted" 
              type="text"
              @input="formatCurrency('min_order_value', $event)"
              class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Tempo Médio de Entrega (min)</label>
            <input 
              v-model="company.average_delivery_time" 
              type="number"
              min="1"
              class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500" 
            />
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Formas de Pagamento Aceitas</label>
          <div class="space-y-2">
            <label class="flex items-center gap-2 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input v-model="paymentMethods" type="checkbox" value="credit_card" class="w-4 h-4 text-orange-600 rounded" />
              <span class="flex items-center gap-2">
                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                </svg>
                Cartão de Crédito/Débito
              </span>
            </label>
            <label class="flex items-center gap-2 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input v-model="paymentMethods" type="checkbox" value="pix" class="w-4 h-4 text-orange-600 rounded" />
              <span class="flex items-center gap-2">
                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4h2v-4zM6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                PIX
              </span>
            </label>
            <label class="flex items-center gap-2 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input v-model="paymentMethods" type="checkbox" value="cash" class="w-4 h-4 text-orange-600 rounded" />
              <span class="flex items-center gap-2">
                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
                Dinheiro
              </span>
            </label>
          </div>
        </div>
        
        <div class="pt-4">
          <button
            @click="saveSettings"
            :disabled="saving"
            class="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="saving" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ saving ? 'Salvando...' : 'Salvar Configurações' }}
          </button>
        </div>
      </div>

      <!-- Aba: Horários de Funcionamento -->
      <div v-if="activeTab === 'hours'" class="space-y-6 max-w-2xl">
        <p class="text-sm text-gray-600">
          Configure os horários de abertura e fechamento da loja para cada dia da semana.
          Eles são exibidos no rodapé do site para os clientes.
        </p>

        <div class="border border-gray-200 rounded-lg divide-y divide-gray-100">
          <div
            v-for="day in weekDays"
            :key="day.key"
            class="flex flex-wrap items-center gap-4 px-4 py-3"
          >
            <span class="w-32 text-sm font-medium text-gray-700">{{ day.label }}</span>

            <label class="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
              <input
                type="checkbox"
                v-model="businessHours[day.key].enabled"
                class="rounded border-gray-300 text-orange-600 focus:ring-orange-500"
              />
              Aberto
            </label>

            <div v-if="businessHours[day.key].enabled" class="flex items-center gap-2">
              <input
                type="time"
                v-model="businessHours[day.key].open"
                class="border rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
              <span class="text-sm text-gray-400">às</span>
              <input
                type="time"
                v-model="businessHours[day.key].close"
                class="border rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>
            <span v-else class="text-sm text-red-500">Fechado</span>
          </div>
        </div>

        <div class="pt-4">
          <button
            @click="saveHours"
            :disabled="savingHours"
            class="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="savingHours" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ savingHours ? 'Salvando...' : 'Salvar Horários' }}
          </button>
        </div>
      </div>

      <!-- Aba: Mercado Pago -->
      <div v-if="activeTab === 'mercadopago'" class="space-y-6 max-w-2xl">
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <div>
              <h4 class="font-medium text-blue-900">Configuração do Mercado Pago</h4>
              <p class="text-sm text-blue-700 mt-1">
                Configure suas credenciais do Mercado Pago para aceitar pagamentos online. 
                Você pode obter suas credenciais no 
                <a href="https://www.mercadopago.com.br/developers" target="_blank" class="underline hover:text-blue-800">painel de desenvolvedores</a>.
              </p>
            </div>
          </div>
        </div>
        
        <!-- Status do Mercado Pago -->
        <div 
          :class="[
            'p-4 rounded-lg border flex items-center gap-3',
            mercadoPagoConfig.enabled 
              ? 'bg-green-50 border-green-200' 
              : 'bg-gray-50 border-gray-200'
          ]"
        >
          <div 
            :class="[
              'w-3 h-3 rounded-full',
              mercadoPagoConfig.enabled ? 'bg-green-500' : 'bg-gray-400'
            ]"
          ></div>
          <span :class="mercadoPagoConfig.enabled ? 'text-green-800 font-medium' : 'text-gray-600'">
            {{ mercadoPagoConfig.enabled ? 'Mercado Pago Ativado' : 'Mercado Pago Desativado' }}
          </span>
        </div>
        
        <!-- Habilitar/Desabilitar -->
        <div class="flex items-center gap-3">
          <label class="relative inline-flex items-center cursor-pointer">
            <input 
              v-model="mercadoPagoConfig.enabled" 
              type="checkbox" 
              class="sr-only peer"
            />
            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-orange-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-orange-600"></div>
            <span class="ml-3 text-sm font-medium text-gray-700">Habilitar Mercado Pago</span>
          </label>
        </div>
        
        <!-- Credenciais (só aparecem quando habilitado) -->
        <div v-if="mercadoPagoConfig.enabled" class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Public Key
              <span class="text-red-500">*</span>
            </label>
            <input 
              v-model="mercadoPagoConfig.public_key" 
              type="text"
              placeholder="TEST-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              class="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 font-mono text-sm" 
            />
            <p class="text-xs text-gray-500 mt-1">Chave pública para inicializar o checkout</p>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Access Token
              <span class="text-red-500">*</span>
            </label>
            <div class="relative">
              <input 
                v-model="mercadoPagoConfig.access_token" 
                :type="showAccessToken ? 'text' : 'password'"
                placeholder="TEST-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-xxxxxxxxxxxxxxxx"
                class="w-full border rounded-lg px-3 py-2 pr-10 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 font-mono text-sm" 
              />
              <button
                @click="showAccessToken = !showAccessToken"
                type="button"
                class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg v-if="showAccessToken" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
                </svg>
                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
              </button>
            </div>
            <p class="text-xs text-gray-500 mt-1">Token de acesso privado para processar pagamentos</p>
          </div>
          
          <!-- Ambiente -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Ambiente</label>
            <div class="flex gap-4">
              <label class="flex items-center gap-2">
                <input 
                  v-model="mercadoPagoConfig.environment" 
                  type="radio" 
                  value="sandbox"
                  class="w-4 h-4 text-orange-600"
                />
                <span class="text-sm">Sandbox (Testes)</span>
              </label>
              <label class="flex items-center gap-2">
                <input 
                  v-model="mercadoPagoConfig.environment" 
                  type="radio" 
                  value="production"
                  class="w-4 h-4 text-orange-600"
                />
                <span class="text-sm">Produção</span>
              </label>
            </div>
          </div>
          
          <!-- Webhook URL -->
          <div class="bg-gray-50 p-4 rounded-lg">
            <label class="block text-sm font-medium text-gray-700 mb-1">Webhook URL</label>
            <div class="flex gap-2">
              <input 
                :value="webhookUrl" 
                type="text"
                readonly
                class="flex-1 border rounded-lg px-3 py-2 bg-gray-100 font-mono text-sm" 
              />
              <button
                @click="copyWebhookUrl"
                type="button"
                class="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm font-medium transition-colors"
              >
                Copiar
              </button>
            </div>
            <p class="text-xs text-gray-500 mt-1">
              Configure esta URL no painel do Mercado Pago para receber notificações de pagamento
            </p>
          </div>
        </div>
        
        <div class="pt-4 flex gap-3">
          <button
            @click="saveMercadoPagoConfig"
            :disabled="savingMp || !isMercadoPagoValid"
            class="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="savingMp" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ savingMp ? 'Salvando...' : 'Salvar Configuração do Mercado Pago' }}
          </button>
          
          <button
            v-if="mercadoPagoConfig.enabled && mercadoPagoConfig.public_key"
            @click="testMercadoPagoConnection"
            :disabled="testingMp"
            class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            <svg v-if="testingMp" class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            {{ testingMp ? 'Testando...' : 'Testar Conexão' }}
          </button>
        </div>
      </div>
      
      <div v-if="activeTab === 'mercadopago' && !company" class="p-8 text-center text-gray-500">
        Carregando configurações...
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { PhotoIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores'
import { companyApi, uploadApi } from '@/utils/api'
import { notifyError, notifySuccess } from '@/utils/notifications'
import { confirmDialog } from '@/composables/useConfirm'
import type { Company } from '@/types'

const authStore = useAuthStore()

// Logo upload
const logoInput = ref<HTMLInputElement | null>(null)
const logoFile = ref<File | null>(null)
const logoPreview = ref<string | null>(null)
const uploadingLogo = ref(false)

const triggerLogoInput = () => {
  logoInput.value?.click()
}

const activeTab = ref('general')

// Estado
const company = ref<Company & { 
  min_order_value?: number
  average_delivery_time?: number
  payment_methods?: string[]
  mercado_pago_config?: any
  system_url?: string
}>({
  id: 0,
  name: '',
  slug: '',
  email: '',
  phone: '',
  whatsapp: '',
  address: '',
  city: '',
  state: '',
  system_url: '',
  zip_code: '',
  description: '',
  logo_url: '',
  primary_color: '#FF6B35',
  secondary_color: '#004E89',
  is_open: true,
  max_delivery_distance: 10,
  min_order_value: 0,
  average_delivery_time: 45,
  payment_methods: ['credit_card', 'pix', 'cash'],
  mercado_pago_config: null,
  default_language: 'pt-BR',
  available_languages: ['pt-BR'],
  is_active: true,
  created_at: new Date().toISOString()
})

const saving = ref(false)
const savingMp = ref(false)
const testingMp = ref(false)
const showAccessToken = ref(false)
const loadingCep = ref(false)
const cepError = ref('')
const lastSearchedCep = ref('')

// Configuração do Mercado Pago
const mercadoPagoConfig = ref({
  enabled: false,
  public_key: '',
  access_token: '',
  environment: 'sandbox'
})

// Webhook URL (usa a URL do sistema configurada ou a URL atual do navegador)
const webhookUrl = computed(() => {
  const baseUrl = company.value.system_url || window.location.origin
  return `${baseUrl}/api/payments/webhook/mercado-pago`
})

// Validação do Mercado Pago
const isMercadoPagoValid = computed(() => {
  if (!mercadoPagoConfig.value.enabled) return true
  return mercadoPagoConfig.value.public_key.trim() !== '' && 
         mercadoPagoConfig.value.access_token.trim() !== ''
})

// Helper para construir URL da imagem
const getImageUrl = (url: string | undefined) => {
  if (!url) return ''
  if (url.startsWith('http')) return url
  return url
}

// Logo upload handlers
const handleLogoChange = (event: Event) => {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file) return
  
  // Valida tamanho (2MB)
  if (file.size > 2 * 1024 * 1024) {
    notifyError('O arquivo é muito grande. Tamanho máximo: 2MB')
    return
  }
  
  // Valida tipo
  if (!file.type.startsWith('image/')) {
    notifyError('Apenas imagens são permitidas')
    return
  }
  
  logoFile.value = file
  
  // Cria preview
  const reader = new FileReader()
  reader.onload = (e) => {
    logoPreview.value = e.target?.result as string
  }
  reader.readAsDataURL(file)
  
  // Faz upload automaticamente
  uploadLogo()
}

const uploadLogo = async () => {
  if (!logoFile.value || !company.value.id) return
  
  uploadingLogo.value = true
  try {
    const formData = new FormData()
    formData.append('file', logoFile.value)
    formData.append('type', 'logo')
    
    const response = await uploadApi.upload(company.value.id, formData)
    company.value.logo_url = response.data.url
    logoFile.value = null
    logoPreview.value = null
    notifySuccess('Logo atualizado com sucesso!')
  } catch (error: any) {
    notifyError('Erro ao fazer upload do logo: ' + (error.response?.data?.detail || 'Erro desconhecido'))
  } finally {
    uploadingLogo.value = false
  }
}

const removeLogo = async () => {
  if (!await confirmDialog({ title: 'Remover logo', message: 'Tem certeza que deseja remover o logo?', danger: true, confirmLabel: 'Remover' })) return
  
  company.value.logo_url = ''
  logoPreview.value = null
  logoFile.value = null
  
  // Salva a remoção
  try {
    await companyApi.update(company.value.id, { logo_url: '' })
    notifySuccess('Logo removido!')
  } catch (error) {
    notifyError('Erro ao remover logo')
  }
}

// Formatação de moeda
const minOrderValueFormatted = computed({
  get: () => {
    const value = company.value.min_order_value || 0
    return (value / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  },
  set: (val: string) => {
    const numeric = val.replace(/[^\d]/g, '')
    company.value.min_order_value = parseInt(numeric) || 0
  }
})

const formatCurrency = (_field: string, event: Event) => {
  const input = event.target as HTMLInputElement
  let value = input.value.replace(/[^\d]/g, '')
  if (value) {
    const numeric = parseInt(value) / 100
    input.value = numeric.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    company.value.min_order_value = parseInt(value)
  }
}

// Métodos de pagamento
const paymentMethods = computed({
  get: () => company.value.payment_methods || [],
  set: (val: string[]) => {
    company.value.payment_methods = val
  }
})

// Horários de funcionamento
// Chaves em pt-BR: o rodapé do site exibe o nome do dia direto da chave
const weekDays = [
  { key: 'segunda', label: 'Segunda-feira' },
  { key: 'terça', label: 'Terça-feira' },
  { key: 'quarta', label: 'Quarta-feira' },
  { key: 'quinta', label: 'Quinta-feira' },
  { key: 'sexta', label: 'Sexta-feira' },
  { key: 'sábado', label: 'Sábado' },
  { key: 'domingo', label: 'Domingo' }
]

const defaultBusinessHours = () => {
  const hours: Record<string, { enabled: boolean; open: string; close: string }> = {}
  for (const day of weekDays) {
    hours[day.key] = {
      enabled: day.key !== 'domingo',
      open: '08:00',
      close: day.key === 'sábado' ? '12:00' : '18:00'
    }
  }
  return hours
}

const businessHours = ref(defaultBusinessHours())
const savingHours = ref(false)

// Carregar empresa
const searchCep = async () => {
  const cep = (company.value.zip_code || '').replace(/\D/g, '')
  if (cep.length !== 8) {
    cepError.value = 'CEP deve ter 8 dígitos'
    return
  }
  if (cep === lastSearchedCep.value) return

  loadingCep.value = true
  cepError.value = ''
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
    const data = await response.json()

    if (data.erro) {
      cepError.value = 'CEP não encontrado'
      lastSearchedCep.value = cep
      return
    }

    company.value.address = data.logradouro || company.value.address
    company.value.city = data.localidade || company.value.city
    company.value.state = data.uf || company.value.state
    lastSearchedCep.value = cep
    cepError.value = ''
  } catch (error) {
    console.error('Erro ao buscar CEP:', error)
    cepError.value = 'Erro ao consultar CEP'
  } finally {
    loadingCep.value = false
  }
}

const loadCompany = async () => {
  const companyId = authStore.companyId || 1
  try {
    const res = await companyApi.getAdmin(companyId)
    company.value = { ...company.value, ...res.data }
    
    // Carregar configuração do Mercado Pago
    if (company.value.mercado_pago_config) {
      mercadoPagoConfig.value = {
        enabled: company.value.mercado_pago_config.enabled || false,
        public_key: company.value.mercado_pago_config.public_key || '',
        access_token: company.value.mercado_pago_config.access_token || '',
        environment: company.value.mercado_pago_config.environment || 'sandbox'
      }
    }

    // Carregar horários de funcionamento salvos
    const savedHours = company.value.opening_hours
    if (savedHours) {
      for (const day of weekDays) {
        const h = savedHours[day.key]
        if (h) {
          businessHours.value[day.key] = {
            enabled: Boolean(h.open && h.close),
            open: h.open || '08:00',
            close: h.close || '18:00'
          }
        }
      }
    }
  } catch (error) {
    console.error('Erro ao carregar empresa:', error)
  }
}

// Salvar configurações gerais
const saveSettings = async () => {
  if (!company.value) return
  
  // Validação de email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(company.value.email)) {
    notifyError('Email inválido')
    return
  }
  
  // Validação de CEP
  const cep = (company.value.zip_code || '').replace(/\D/g, '')
  if (cep.length !== 8) {
    notifyError('CEP inválido. Deve conter 8 dígitos.')
    return
  }
  if (cepError.value) {
    notifyError('CEP inválido: ' + cepError.value)
    return
  }
  
  saving.value = true
  try {
    // Limpa o objeto reativo antes de enviar
    const dataToSave = JSON.parse(JSON.stringify({
      ...company.value,
      payment_methods: paymentMethods.value
    }))
    await companyApi.update(company.value.id, dataToSave)
    notifySuccess('Configurações salvas com sucesso!')
  } catch (error: any) {
    const detail = error.response?.data?.detail || error.message || 'Erro desconhecido'
    notifyError('Erro ao salvar configurações: ' + detail)
  } finally {
    saving.value = false
  }
}

// Salvar horários de funcionamento
const saveHours = async () => {
  if (!company.value) return

  // Monta o payload no formato do backend; dia fechado = open/close vazios
  const payload: Record<string, { open: string; close: string }> = {}
  for (const day of weekDays) {
    const h = businessHours.value[day.key]
    if (h.enabled) {
      if (!h.open || !h.close) {
        notifyError(`Informe os horários de ${day.label} ou desmarque "Aberto".`)
        return
      }
      payload[day.key] = { open: h.open, close: h.close }
    } else {
      payload[day.key] = { open: '', close: '' }
    }
  }

  savingHours.value = true
  try {
    await companyApi.update(company.value.id, { opening_hours: payload })
    company.value.opening_hours = payload
    notifySuccess('Horários salvos com sucesso!')
  } catch (error: any) {
    const detail = error.response?.data?.detail || error.message || 'Erro desconhecido'
    notifyError('Erro ao salvar horários: ' + detail)
  } finally {
    savingHours.value = false
  }
}

// Salvar configuração do Mercado Pago
const saveMercadoPagoConfig = async () => {
  if (!company.value) return
  
  savingMp.value = true
  try {
    // Limpa o objeto reativo antes de enviar
    const cleanConfig = JSON.parse(JSON.stringify(mercadoPagoConfig.value))
    await companyApi.update(company.value.id, {
      mercado_pago_config: cleanConfig
    })
    notifySuccess('Configuração do Mercado Pago salva com sucesso!')
  } catch (error: any) {
    const detail = error.response?.data?.detail || error.message || 'Erro desconhecido'
    notifyError('Erro ao salvar configuração do Mercado Pago: ' + detail)
  } finally {
    savingMp.value = false
  }
}

// Testar conexão com Mercado Pago
const testMercadoPagoConnection = async () => {
  testingMp.value = true
  try {
    const response = await companyApi.testMercadoPago(company.value.id)
    const data = response.data
    notifySuccess(`${data.message} Usuário: ${data.data.nickname} Ambiente: ${data.data.environment}`)
  } catch (error: any) {
    const message = error.response?.data?.detail || 'Erro ao testar conexão com Mercado Pago'
    notifyError(message)
  } finally {
    testingMp.value = false
  }
}

// Copiar webhook URL
const copyWebhookUrl = () => {
  navigator.clipboard.writeText(webhookUrl.value)
  notifySuccess('URL copiada para a área de transferência!')
}

onMounted(() => {
  loadCompany()
})
</script>
